<template>
  <div class="not-found-page">
    <div class="error-code">
      4<span class="drone-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="0.8em"
          height="0.8em"
          viewBox="0 0 48 48"
        >
          <path
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="4"
            d="m12 12l7 7m17 17l-7-7m7-17l-7 7M12 36l7-7m0-10h10v10H19zm17 0a7 7 0 1 0-7-7m7 17a7 7 0 1 1-7 7m-17-7a7 7 0 1 0 7 7m-7-17a7 7 0 1 1 7-7"
          />
        </svg> </span
      >4
    </div>

    <h1 class="title">页面暂时飞离了基站</h1>
    <p class="description">我们的无人机团队正在全力搜寻中</p>

    <!-- 按钮容器 -->
    <el-button
      class="mx-auto flex justify-center items-center home-button"
      @mouseenter="hoverButton = true"
      @mouseleave="hoverButton = false"
      @click="goHome"
    >
      <i class="el-icon-position"></i>
      返回控制中心
    </el-button>

    <div class="background-drones">
      <div class="drone" v-for="i in 18" :key="i">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1em"
          height="1em"
          viewBox="0 0 48 48"
        >
          <path
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="4"
            d="m12 12l7 7m17 17l-7-7m7-17l-7 7M12 36l7-7m0-10h10v10H19zm17 0a7 7 0 1 0-7-7m7 17a7 7 0 1 1-7 7m-17-7a7 7 0 1 0 7 7m-7-17a7 7 0 1 1 7-7"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  data() {
    return {
      drones: [], // 存储所有无人机元素的状态
      animationFrame: null, // 用于存储动画帧ID
    };
  },
  methods: {
    // 返回首页
    goHome() {
      this.$router.push("/");
    },

    // 初始化无人机位置和速度
    initDrones() {
      const container = document.querySelector(".background-drones");
      if (!container) return;

      this.drones = Array.from(container.querySelectorAll(".drone")).map(
        (drone) => {
          const maxX = container.clientWidth - 60;
          const maxY = container.clientHeight - 60;
          // 从中心点开始计算位置
          const centerX = container.clientWidth / 2 - 30;
          const centerY = container.clientHeight / 2 - 30;
          // 随机偏移量
          const offsetX = (Math.random() - 0.5) * maxX;
          const offsetY = (Math.random() - 0.5) * maxY;
          const x = centerX + offsetX;
          const y = centerY + offsetY;
          const speed = 1 + Math.random() * 2;
          const angle = Math.random() * Math.PI * 2;
          const vx = Math.cos(angle) * speed;
          const vy = Math.sin(angle) * speed;

          return { element: drone, x, y, vx, vy };
        }
      );
    },

    // 更新无人机位置
    updateDrones() {
      const container = document.querySelector(".background-drones");
      if (!container) return;

      const maxX = container.clientWidth - 60;
      const maxY = container.clientHeight - 60;

      this.drones.forEach((drone) => {
        let newX = drone.x + drone.vx;
        let newY = drone.y + drone.vy;

        // 边界检测和反弹
        if (newX < 0 || newX > maxX) {
          drone.vx *= -1;
          newX = newX < 0 ? 0 : maxX;
        }
        if (newY < 0 || newY > maxY) {
          drone.vy *= -1;
          newY = newY < 0 ? 0 : maxY;
        }

        // 计算旋转角度并应用变换
        const angle = (Math.atan2(drone.vy, drone.vx) * 180) / Math.PI + 90;
        drone.element.style.transform = `translate(${newX}px, ${newY}px) rotate(${angle}deg)`;

        drone.x = newX;
        drone.y = newY;
      });

      // 请求下一帧动画
      this.animationFrame = requestAnimationFrame(this.updateDrones.bind(this));
    },
  },
  mounted() {
    // DOM更新后初始化无人机动画
    this.$nextTick(() => {
      this.initDrones();
      this.updateDrones();
    });
  },
  beforeDestroy() {
    // 组件销毁前清除动画帧
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }
  },
};
</script>

<style scoped>
/* 页面容器样式 */
.not-found-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 2vw;
  position: relative;
  overflow: hidden;
}

/* 错误代码样式 */
.error-code {
  font-size: 8vw;
  font-weight: 800;
  color: #2c3e50;
  margin-bottom: 1vw;
  position: relative;
}

/* 404无人机图标动画 */
.drone-icon {
  display: inline-block;
  animation: rotate 8s linear infinite;
  margin: 0 1vw; /* 添加左右间距 */
}

/* 标题样式 */
.title {
  font-size: 1.8vw;
  color: #34495e;
  margin-bottom: 1vw;
}

/* 描述文字样式 */
.description {
  font-size: 1vw;
  color: #7f8c8d;
  margin-bottom: 2vw;
  text-align: center;
}

/* 省略号动画 */
.description::after {
  content: "";
  animation: ellipsis 1.5s infinite steps(4, end);
}

@keyframes ellipsis {
  0% {
    content: "";
  }
  25% {
    content: ".";
  }
  50% {
    content: "..";
  }
  75% {
    content: "...";
  }
  100% {
    content: "";
  }
}

/* 返回按钮基础样式 */
.home-button {
  width: 7.8vw !important;
  height: 2.6vw !important;

  background: #05358c !important;
  border: none !important;
  border-radius: 0.25vw !important;
  transition: all 0.3s !important;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
}
.home-button :deep(span) {
  color: rgb(255, 255, 255) !important;
  font-size: 0.78vw !important;
  font-weight: normal !important;
  font-family: "HarmonyOS Sans SC" !important;
}

.home-button:hover {
  background: #1c9af3;
  transform: translateY(-0.1vw);
  box-shadow: 0 0.2vw 0.6vw rgba(64, 158, 255, 0.3);
}

/* 背景无人机容器 */
.background-drones {
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
}

/* 单个无人机样式 */
.drone {
  position: absolute;
  width: 3.8vw;
  height: 3.8vw;
  opacity: 0.15;
  transition: transform 0.3s ease-out;
}

/* 无人机图标 */
.drone::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
}

.drone svg {
  width: 100%;
  height: 100%;
  stroke: currentColor;
}

/* 旋转动画关键帧 */
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
